import { render, staticRenderFns } from "./portal-card.vue?vue&type=template&id=3b5df23e&scoped=true"
import script from "./portal-card.vue?vue&type=script&lang=js"
export * from "./portal-card.vue?vue&type=script&lang=js"
import style0 from "./portal-card.vue?vue&type=style&index=0&id=3b5df23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5df23e",
  null
  
)

export default component.exports